Mmg.addShortcode(
    'multi_profession_job_list',
    '.sc-multi-profession-job-list',

    /**
     * @param {Element} el        The shortcode's DOM element
     * @param {object}  model     Data from data-json
     * @param {jQuery}  $         jQuery
     * @param {string}  selector  The shortcode selector
     */
    (el, model, $, selector) => {

        const $widget = $(el);
        const $groups = $widget.find(`${selector}__groups`);
        const $shownCount = $widget.find(`${selector}__shown-count`);
        const $totalCount = $widget.find(`${selector}__total-count`);
        const $loadMore = $widget.find(`${selector}__load-more`);
        const $sortSelect = $widget.find(`${selector}__sort-select`);
        const template = $widget.find(`${selector}__job-template`).html();
        const groupTemplate = $widget.find(`${selector}__group-template`).html();

        let activeRequest = null;
        let activeProfessionId = null;
        let activeSort = $sortSelect.val();
        let page = 1;
        let loadedGroups = [];
        let loadedGroupIndex = {};
        let loadedCount = parseInt(model.initial_count) || 0;
        let totalCount = parseInt(model.job_count) || 0;

        (function init() {
            addEvents();
        })();


        /**
         * Bind all widget-level event listeners.
         */
        function addEvents() {
            $widget.on('click', `${selector}__profession-toggle`, onProfessionClick);
            $loadMore.on('click', onLoadMoreClick);
            $sortSelect.on('change', onSortChange);
        }


        /**
         * Handle sort dropdown change: reset to page 1 and re-fetch.
         */
        function onSortChange() {
            activeSort = $sortSelect.val();
            resetAndFetch();
        }


        /**
         * Handle profession button click: filter by profession, reset to page 1, re-fetch.
         */
        function onProfessionClick(event) {
            const $button = $(this);
            event.preventDefault();

            if ($button.hasClass('active')) {
                return;
            }

            $widget.find(`${selector}__profession-toggle`).removeClass('active');
            $button.addClass('active');
            activeProfessionId = $button.data('profession-id') || null;
            totalCount = activeProfessionId ? model.profession_counts[activeProfessionId] : parseInt(model.job_count) || 0;
            resetAndFetch();
        }


        /**
         * Handle Load More click: fetch the next page and merge its groups into loadedGroups.
         * On the first click from SSR state (loadedGroups empty), re-fetches page 1 first so groups merge correctly.
         */
        function onLoadMoreClick(event) {
            event.preventDefault();

            if (!loadedGroups.length) {
                // SSR rendered page 1; fetch pages 1-2 together in one request to prime loadedGroups.
                page = 1;
                fetchPage(20);
                page = 2;
            } else {
                page++;
                fetchPage();
            }
        }


        /**
         * Reset state to page 1 and fetch fresh results (used by sort and profession filter changes).
         */
        function resetAndFetch() {
            loadedGroups = [];
            loadedGroupIndex = {};
            page = 1;
            fetchPage();
        }


        /**
         * Fire a GET request for the current page, merge results into loadedGroups, and re-render.
         *
         * @param {number} [limit]  Jobs per page; defaults to 10 on the server. Pass 20 to fetch two pages in one request.
         */
        function fetchPage(limit) {
            const [sortField, sortDir] = activeSort.split(':');
            const params = {
                region_id: model.region_id,
                state_id: model.state_id,
                region_level: model.region_level,
                region_name: model.region_name,
                group_by_region: model.group_by_region,
                filters: {
                    profession_id: activeProfessionId,
                    facility_type: model.facility_type,
                },
                sort: sortField,
                sort_direction: sortDir,
                page: page,
                limit: limit,
            };

            if (activeRequest && activeRequest.readyState !== 4) {
                activeRequest.abort();
            }

            activeRequest = $.ajax({
                url: model.rest_url,
                method: 'GET',
                data: params,
            })
            .done(function(response) {
                mergeGroups(response.groups);
                loadedCount = loadedGroups.reduce(function(sum, group) {
                    return sum + group.jobs.length;
                }, 0);
                $groups.html(buildGroupsHtml());
                updateCountUI();
            });
        }


        /**
         * Merge a page's server-grouped jobs into loadedGroups, appending to an
         * existing group when its group_key was already seen on a prior page.
         *
         * @param {Array} groups  [{group_key, group_intro, jobs}]
         */
        function mergeGroups(groups) {
            groups.forEach(function(group) {
                if (loadedGroupIndex[group.group_key] === undefined) {
                    loadedGroupIndex[group.group_key] = loadedGroups.length;
                    loadedGroups.push({ group_key: group.group_key, group_intro: group.group_intro, jobs: [] });
                }
                const target = loadedGroups[loadedGroupIndex[group.group_key]];
                target.jobs = target.jobs.concat(group.jobs);
            });
        }


        /**
         * Re-render the full loadedGroups set into grouped HTML.
         *
         * @return {string}
         */
        function buildGroupsHtml() {
            return loadedGroups.map(renderGroup).join('');
        }


        /**
         * Render one group: render each job, then render the group template using
         * the server-provided intro text.
         *
         * @param {object} group
         * @return {string}
         */
        function renderGroup(group) {
            const jobs = group.jobs.map(function(job) {
                return Mustache.render(template, job);
            });
            return Mustache.render(groupTemplate, { group_intro: group.group_intro, jobs });
        }


        /**
         * Update the count label and show/hide the Load More button.
         */
        function updateCountUI() {
            $shownCount.text(loadedCount.toLocaleString());
            $totalCount.text(totalCount.toLocaleString());

            const remaining = totalCount - loadedCount;
            if (remaining > 0) {
                $loadMore.text(`Load More (${Math.min(10, remaining)} of ${remaining.toLocaleString()} remaining)`);
                $loadMore.show();
            } else {
                $loadMore.hide();
            }
        }


    }
);
